import { t } from "i18next";
import { useEffect, useState } from "react";
import SPONSORICON from "../../images/sponsoricon.svg";
import { SponsorContainer } from "../atoms/Cards";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import "../../styles/Common.css";
import { RemoveProfilePicBlur } from "../atoms/MyAccountView";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  textcontainer: {
    borderRadius: 30,
    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 5,
    paddingBottom: 5,
    backgroundColor: "white",
  },
  sponsorImageWrapper: {
    marginBottom: -10,
    marginTop: -30,
  },
  sponsorImage: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    objectFit: "contain",
    position: "relative",
  },
  inputstyle1: {
    alignSelf: "center",
    fontFamily: "Lato-SemiBold",
    fontSize: "18px"
  },
};

export default function SponsorMarkerView(props) {

  const [showNotification, setShowNotification] = useState(false);
  const { worldReducer } = useSelector((state) => state);

  useEffect(() => {
    if (worldReducer?.getSponsorChildCoordinates && worldReducer?.getSponsorChildCoordinates?.responseSource === null) {
      if (!worldReducer.getSponsorChildCoordinates?.contactDetailsNotificationTimeStamp) {
        setShowNotification(true);
      } else {
        let currentDate = moment();
        let notificationDate = moment(worldReducer?.getSponsorChildCoordinates?.contactDetailsNotificationTimeStamp);
        let diff = currentDate.diff(notificationDate, "days");
        if (diff > 365) setShowNotification(true);
      }
    }
  }, [worldReducer]);

  const profileImg = props?.image;
  const renderSponsorContainer = () => (
    <SponsorContainer style={styles.container} onClick={props?.handleRedirect}>
      {props?.image && props?.image.length > 0 ? (
        <RemoveProfilePicBlur style={{...styles.sponsorImageWrapper, width:60, height:60, borderRadius:"50%"}} background={profileImg}>
          <img src={profileImg} style={styles.sponsorImage} alt="" />
        </RemoveProfilePicBlur>
      ) : (
        <img src={SPONSORICON} style={styles.sponsorImage} alt="" />
      )}
      <div className={`textcontainer ${showNotification ? "textcontainer-notification" : " "}`}>
        {showNotification && <div className="circleupdate">{1}</div>}
        <span style={styles.inputstyle1}>{t("Me")}</span>
      </div>
    </SponsorContainer>
  );

  return (
    <>
      {props?.soCode === "FINO" ?
        <OverlayTrigger placement="top" overlay={props?.sponsorID === "" ? <></> : <Tooltip style={{ pointerEvents: "none", marginBottom: "5px" }}>{t("SupporterID")} {props?.sponsorID}</Tooltip>}>
          {renderSponsorContainer()}
        </OverlayTrigger>
        :
        renderSponsorContainer()
      }
    </>
  );
}
